export const state = () => ({
  loading: false,
  agentFloatingIcons: {}
})

export const actions = {
  async agentFloatingIcons({ commit, rootState }) {}
}

export const mutations = {
  setLoading: (state, v) => {
    state.loading = v
  },
  agentFloatingIcons: (state, v) => {
    state.agentFloatingIcons = v
  }
}

export const getters = {
  agentFloatingSupportIcon: (state, getters, rootState) => {
    const data = rootState.cms.floatingIcons.data
    return data || {}
  }
}
